(function () {
  if (window.__productRecommendationsCarouselDelegated) return;
  window.__productRecommendationsCarouselDelegated = true;

  function cardStep(track) {
    var card = track.querySelector('.product-thumbnail');
    if (!card) return track.clientWidth * 0.8;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function updateNav(carousel) {
    var track = carousel.querySelector('[data-product-track]');
    if (!track) return;
    var prevBtn = carousel.querySelector('[data-pr-nav="prev"]');
    var nextBtn = carousel.querySelector('[data-pr-nav="next"]');
    var maxScroll = track.scrollWidth - track.clientWidth - 1;
    if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0;
    if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll;
  }

  function checkArrowsVisibility(carousel) {
    var track = carousel.querySelector('[data-product-track]');
    if (!track) return;
    var productsPerRow = parseInt(carousel.getAttribute('data-products-per-row'), 10) || 4;
    var count = track.querySelectorAll('.product-thumbnail').length;
    var noArrows = count > 0 && count <= productsPerRow;
    carousel.classList.toggle('product-recommendations__carousel--no-arrows', noArrows);
  }

  // Cards injected after page load (dynamic recommendations, recently viewed)
  // ship an empty Yotpo star-rating widget that Yotpo never initialises on
  // its own (it only scans at page load). Ask the rating script to init +
  // format them once per card; the marker prevents re-triggering when Yotpo's
  // own DOM updates fire this observer again.
  function hydrateNewRatings(carousel) {
    var api = window.VoyagerProductCardRatings;
    if (!api || typeof api.refresh !== 'function') return;
    var fresh = carousel.querySelectorAll('.product-thumbnail__rating--yotpo:not([data-pr-rating-requested])');
    if (!fresh.length) return;
    fresh.forEach(function (el) { el.setAttribute('data-pr-rating-requested', 'true'); });
    api.refresh(carousel);
    // Yotpo can still be loading on a slow connection - one late retry for any
    // widget that is still empty.
    window.setTimeout(function () {
      if (carousel.querySelector('.product-thumbnail__rating--yotpo:not(.voyager-yotpo-rating--ready):not(.voyager-yotpo-rating--empty) .yotpo-widget-instance:empty')) {
        api.refresh(carousel);
      }
    }, 3500);
  }

  function refreshAllCarousels() {
    document.querySelectorAll('[data-product-carousel]').forEach(function (carousel) {
      checkArrowsVisibility(carousel);
      updateNav(carousel);
      hydrateNewRatings(carousel);
    });
  }

  document.addEventListener('click', function (e) {
    var navBtn = e.target.closest('[data-pr-nav]');
    if (!navBtn) return;
    var carousel = navBtn.closest('[data-product-carousel]');
    var track = carousel && carousel.querySelector('[data-product-track]');
    if (!track) return;
    var step = cardStep(track);
    if (!step) return;
    track.scrollBy({ left: navBtn.getAttribute('data-pr-nav') === 'next' ? step : -step, behavior: 'smooth' });
  });

  // scroll does not bubble, so this must listen during the capture phase
  // to catch scrolling on any (possibly not-yet-existing) track.
  document.addEventListener('scroll', function (e) {
    var track = e.target.closest && e.target.closest('[data-product-track]');
    var carousel = track && track.closest('[data-product-carousel]');
    if (carousel) updateNav(carousel);
  }, true);

  window.addEventListener('resize', refreshAllCarousels);

  // Dynamic recommendations are fetched and injected asynchronously by the
  // theme's existing ProductRecommendations JS class - re-check whenever
  // any matching content changes anywhere on the page.
  var observer = new MutationObserver(refreshAllCarousels);
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAllCarousels);
  } else {
    refreshAllCarousels();
  }
})();
